/**
 * Copy of the "Escrituração, municípios e atividades" part of the entity's Regime & Alíquotas tab
 * (ALC-4764). Error keys are the codes the API answers with (`details.code`).
 */
export const establishmentProfilePtBr = {
  common: {
    pending: 'Pendente de salvar',
    add: 'Adicionar',
    cancel: 'Cancelar',
    remove: 'Remover',
    retry: 'Tentar novamente',
    loading: 'Carregando…',
    loadError: 'Não foi possível carregar estes dados.',
    validFrom: 'Início da vigência',
    validTo: 'Fim da vigência',
    since: 'Desde {{from}}',
    range: 'De {{from}} até {{to}}',
    current: 'Em vigor',
    dateInvalid: 'Informe uma data válida.',
    endBeforeStart: 'O fim da vigência não pode ser anterior ao início.',
    optional: 'opcional',
    noPermission:
      'Você não tem permissão para ver a escrituração, os municípios e as atividades. Peça acesso a quem administra o cadastro da empresa.',
  },
  bookkeeping: {
    title: 'Escrituração contábil',
    description:
      'Tipo de escrituração do contribuinte, decidido e aprovado por você. O regime tributário não define a escrituração.',
    types: {
      COMPLETE: 'Completa',
      SIMPLIFIED: 'Simplificada',
    },
    empty:
      'Nenhum tipo de escrituração registrado. Registre o tipo para que obrigações e livros saibam como escriturar.',
    taxpayerRequired:
      'Esta entidade ainda não tem contribuinte federal. Informe a identidade do contribuinte em Informações básicas para registrar a escrituração.',
    goToBasic: 'Ir para Informações básicas',
    headOfficeOnly:
      'A escrituração vale para todo o contribuinte e só é alterada na matriz. Aqui você vê o que está registrado.',
    noCompanyAccess:
      'A escrituração vale para toda a empresa. Para alterá-la, você precisa de acesso a todos os estabelecimentos. Peça esse acesso a quem administra os acessos. Aqui você vê o que está registrado.',
    headOfficeMissing: 'A matriz do contribuinte não está identificada.',
    openHeadOffice: 'Abrir a matriz',
    approvedOn: 'Aprovada em {{date}}',
    evidenceLine: 'Evidência: {{code}}',
    register: 'Registrar nova vigência',
    formTitle: 'Nova vigência da escrituração',
    type: 'Tipo de escrituração',
    typePlaceholder: 'Escolha o tipo',
    evidenceCode: 'Código da evidência',
    evidenceDescription: 'Descrição da evidência',
    approval:
      'Aprovo expressamente este tipo de escrituração. Sei que o regime tributário não o define.',
    startsOn: 'Passa a valer em {{date}}, quando você salvar.',
    closesPrevious: 'A vigência atual termina no dia anterior.',
  },
  municipalities: {
    title: 'Municípios atendidos',
    description:
      'Onde este estabelecimento presta serviço, com vigência. O município padrão de ISS, acima, continua sendo o usado na emissão da NFS-e.',
    empty: 'Nenhum município registrado para este estabelecimento.',
    pick: 'Município',
    pickPlaceholder: 'Busque pelo nome do município',
    register: 'Adicionar município',
    itemLine: '{{name}} - {{state}}',
    ibge: 'IBGE {{code}}',
  },
  activities: {
    title: 'Atividades exercidas',
    description:
      'Os serviços do catálogo LC 116 que este estabelecimento presta, com vigência. Obrigações municipais e de ISS usam esta lista.',
    empty: 'Nenhuma atividade registrada para este estabelecimento.',
    pick: 'Atividade',
    pickPlaceholder: 'Busque pelo código ou nome do serviço',
    register: 'Adicionar atividade',
    lc116: 'LC 116 {{code}}',
  },
  served: {
    end: 'Encerrar',
    endOn: 'Encerrar em',
    endGroup: 'Encerrar vigência',
    confirmEnd: 'Confirmar',
    endsOn: 'Encerra em {{date}}',
    listLabel: 'Vigências registradas',
    overlap:
      'Este item já tem uma vigência que cobre parte do período. Encerre a anterior primeiro.',
    itemRequired: 'Escolha o item.',
    endInvalid: 'O encerramento fica entre o início e o fim atual da vigência.',
  },
  errors: {
    generic: 'Não foi possível salvar escrituração, municípios e atividades. Tente novamente.',
    ESTABLISHMENT_PROFILE_DATE_INVALID:
      'Informe datas válidas. O fim da vigência não pode ser anterior ao início.',
    ESTABLISHMENT_PROFILE_OVERLAP:
      'Este item já tem uma vigência que cobre parte do período. Encerre a anterior antes de registrar a nova.',
    ESTABLISHMENT_PROFILE_APPROVED_PERIOD_LOCKED:
      'Uma apuração aprovada usa este período. Reabra ou substitua a apuração antes de alterá-lo.',
    ESTABLISHMENT_PROFILE_RETRY:
      'A configuração mudou durante o salvamento. Atualize a página e tente novamente.',
    ESTABLISHMENT_PROFILE_ENTITY_NOT_FOUND: 'Não encontramos a entidade. Atualize a página.',
    ESTABLISHMENT_PROFILE_TAXPAYER_NOT_FOUND:
      'Não encontramos o contribuinte federal. Atualize a página.',
    ESTABLISHMENT_PROFILE_TAXPAYER_REQUIRED:
      'A entidade não tem contribuinte federal. Informe a identidade do contribuinte em Informações básicas.',
    ESTABLISHMENT_PROFILE_HEAD_OFFICE_ONLY:
      'A escrituração só é alterada na matriz do contribuinte.',
    ESTABLISHMENT_PROFILE_ENTITY_SCOPE_FORBIDDEN:
      'Esta entidade está fora do seu escopo de acesso. Peça a um administrador para ampliar o acesso.',
    BOOKKEEPING_TYPE_APPROVAL_REQUIRED:
      'Confirme a aprovação expressa para registrar o tipo de escrituração.',
    BOOKKEEPING_TYPE_EVIDENCE_REQUIRED:
      'Informe o código e a descrição da evidência do tipo de escrituração.',
    BOOKKEEPING_TYPE_MISSING: 'Não há tipo de escrituração válido para esta data.',
    BOOKKEEPING_TYPE_PERIOD_GAP: 'Há uma lacuna no tipo de escrituração no período informado.',
    BOOKKEEPING_TYPE_PERIOD_OVERLAP:
      'Há vigências de escrituração sobrepostas no período informado.',
    BOOKKEEPING_TYPE_PERIOD_CHANGE: 'O período informado atravessa uma mudança de escrituração.',
    SERVED_MUNICIPALITY_NOT_FOUND: 'O município não existe no catálogo.',
    SERVED_ACTIVITY_NOT_FOUND: 'A atividade não existe no catálogo.',
    SERVED_ITEM_NOT_FOUND:
      'Não encontramos a vigência que seria encerrada. Atualize a página e tente novamente.',
    SERVED_ITEM_END_INVALID:
      'Uma vigência só pode ser encerrada em data igual ou posterior ao início, e nunca estendida.',
  },
} as const;

type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };

export const establishmentProfileEn: Shape<typeof establishmentProfilePtBr> = {
  common: {
    pending: 'Pending save',
    add: 'Add',
    cancel: 'Cancel',
    remove: 'Remove',
    retry: 'Try again',
    loading: 'Loading…',
    loadError: 'Could not load this data.',
    validFrom: 'Validity start',
    validTo: 'Validity end',
    since: 'Since {{from}}',
    range: 'From {{from}} to {{to}}',
    current: 'In effect',
    dateInvalid: 'Enter a valid date.',
    endBeforeStart: 'The validity end cannot be before its start.',
    optional: 'optional',
    noPermission:
      "You do not have permission to see the bookkeeping, municipalities and activities. Ask whoever manages the company's settings for access.",
  },
  bookkeeping: {
    title: 'Bookkeeping',
    description:
      'How the Taxpayer keeps its accounting books, decided and approved by you. The tax regime does not define it.',
    types: {
      COMPLETE: 'Complete',
      SIMPLIFIED: 'Simplified',
    },
    empty:
      'No bookkeeping type recorded. Record it so obligations and ledgers know how to keep the books.',
    taxpayerRequired:
      'This entity has no federal Taxpayer yet. Set the taxpayer identity in Basic information to record the bookkeeping.',
    goToBasic: 'Go to Basic information',
    headOfficeOnly:
      'Bookkeeping applies to the whole Taxpayer and is changed on the head office only. Here you see what is recorded.',
    noCompanyAccess:
      'Bookkeeping applies to the whole company. To change it, you need access to every establishment. Ask the person who manages access for it. Here you see what is recorded.',
    headOfficeMissing: 'The Taxpayer head office is not identified.',
    openHeadOffice: 'Open the head office',
    approvedOn: 'Approved on {{date}}',
    evidenceLine: 'Evidence: {{code}}',
    register: 'Record new validity',
    formTitle: 'New bookkeeping validity',
    type: 'Bookkeeping type',
    typePlaceholder: 'Choose the type',
    evidenceCode: 'Evidence code',
    evidenceDescription: 'Evidence description',
    approval:
      'I expressly approve this bookkeeping type. I know the tax regime does not define it.',
    startsOn: 'Takes effect on {{date}}, when you save.',
    closesPrevious: 'The current validity ends the day before.',
  },
  municipalities: {
    title: 'Municipalities served',
    description:
      'Where this establishment renders services, with validity. The default ISS municipality, above, is still the one used to issue NFS-e.',
    empty: 'No municipality recorded for this establishment.',
    pick: 'Municipality',
    pickPlaceholder: 'Search by municipality name',
    register: 'Add municipality',
    itemLine: '{{name}} - {{state}}',
    ibge: 'IBGE {{code}}',
  },
  activities: {
    title: 'Activities performed',
    description:
      'The LC 116 catalog services this establishment renders, with validity. Municipal and ISS obligations use this list.',
    empty: 'No activity recorded for this establishment.',
    pick: 'Activity',
    pickPlaceholder: 'Search by service code or name',
    register: 'Add activity',
    lc116: 'LC 116 {{code}}',
  },
  served: {
    end: 'End',
    endOn: 'End on',
    endGroup: 'End validity',
    confirmEnd: 'Confirm',
    endsOn: 'Ends on {{date}}',
    listLabel: 'Recorded validities',
    overlap:
      'This item already has a validity covering part of the period. End the earlier one first.',
    itemRequired: 'Choose the item.',
    endInvalid: 'The end must fall between the start and the current end of the validity.',
  },
  errors: {
    generic: 'Could not save bookkeeping, municipalities and activities. Try again.',
    ESTABLISHMENT_PROFILE_DATE_INVALID:
      'Enter valid dates. The validity end cannot be before its start.',
    ESTABLISHMENT_PROFILE_OVERLAP:
      'This item already has a validity covering part of the period. End the earlier one before recording the new one.',
    ESTABLISHMENT_PROFILE_APPROVED_PERIOD_LOCKED:
      'An approved assessment uses this period. Reopen or replace the assessment before changing it.',
    ESTABLISHMENT_PROFILE_RETRY:
      'The configuration changed while it was being saved. Refresh the page and try again.',
    ESTABLISHMENT_PROFILE_ENTITY_NOT_FOUND: 'The entity was not found. Refresh the page.',
    ESTABLISHMENT_PROFILE_TAXPAYER_NOT_FOUND:
      'The federal Taxpayer was not found. Refresh the page.',
    ESTABLISHMENT_PROFILE_TAXPAYER_REQUIRED:
      'The entity has no federal Taxpayer. Set the taxpayer identity in Basic information.',
    ESTABLISHMENT_PROFILE_HEAD_OFFICE_ONLY:
      'Bookkeeping is changed on the Taxpayer head office only.',
    ESTABLISHMENT_PROFILE_ENTITY_SCOPE_FORBIDDEN:
      'This entity is outside your access scope. Ask an administrator to widen your access.',
    BOOKKEEPING_TYPE_APPROVAL_REQUIRED:
      'Confirm the express approval to record the bookkeeping type.',
    BOOKKEEPING_TYPE_EVIDENCE_REQUIRED:
      'Enter the evidence code and description of the bookkeeping type.',
    BOOKKEEPING_TYPE_MISSING: 'No bookkeeping type covers this date.',
    BOOKKEEPING_TYPE_PERIOD_GAP: 'There is a bookkeeping gap inside the period.',
    BOOKKEEPING_TYPE_PERIOD_OVERLAP: 'Bookkeeping validities overlap inside the period.',
    BOOKKEEPING_TYPE_PERIOD_CHANGE: 'The period crosses a change of bookkeeping type.',
    SERVED_MUNICIPALITY_NOT_FOUND: 'The municipality is not in the catalog.',
    SERVED_ACTIVITY_NOT_FOUND: 'The activity is not in the catalog.',
    SERVED_ITEM_NOT_FOUND: 'The validity to end was not found. Refresh the page and try again.',
    SERVED_ITEM_END_INVALID:
      'A validity can only be ended on or after its start, and never extended.',
  },
};
